import React, { useEffect } from 'react';
import { Crisp } from 'crisp-sdk-web';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Notification from '@teetsh/app/src/containers/App/Notifications';
import AppProvider from '@teetsh/app/src/containers/App/context';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useHydrateAtoms } from 'jotai/react/utils';
import { Provider } from 'jotai/react';
import { queryClientAtom } from 'jotai-tanstack-query';
import { queryClient } from './queryClient';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DEFAULT_LANGUAGE = 'fr';

const HydrateAtoms = ({ initialValues, children }) => {
  useHydrateAtoms(initialValues);
  return children;
};
export default function App() {
  const { i18n } = useTranslation();
  const langCode = i18n.language?.split('-')[0] || DEFAULT_LANGUAGE;

  useEffect(() => {
    if (
      import.meta.env.VITE_IS_DEV === 'false' &&
      window.self === window.top && // Prevent Crisp from being injected in iframes
      !Crisp.isCrispInjected() &&
      !window.navigator.userAgent.includes('HeadlessChrome')
    ) {
      Crisp.configure(`${import.meta.env.VITE_CRISP_WEBSITE_TOKEN}`, {
        sessionMerge: true,
      });
      // eslint-disable-next-line no-console
      console.log('Crisp injected');
    }
  }, []);

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s - Teetsh" defaultTitle="Teetsh">
        <html lang={langCode} />
        <meta
          name="description"
          content="Teetsh est un outil pour les professeurs des écoles"
        />
      </Helmet>
      <GoogleOAuthProvider clientId="2076456741-f29am1dobl0tksmpnirojm9pt8addqud.apps.googleusercontent.com">
        <QueryClientProvider client={queryClient}>
          <Provider>
            <HydrateAtoms initialValues={[[queryClientAtom, queryClient]]}>
              <AppProvider>
                <Outlet />
                {false && <ReactQueryDevtools initialIsOpen={false} />}
                <Notification />
              </AppProvider>
            </HydrateAtoms>
          </Provider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
}
